import translations from './spanish';


export default function CustomTranslate(template, replacements) {
    replacements = replacements || {};

    // Translate
    template = translations[template] || template;

    // Replace
    return template.replace(/{([^}]+)}/g, function(_, key) {
        return translations[replacements[key]] || '{' + key + '}';
    });
}
